export default __webpack_public_path__ + "static/media/taxt-black.6be934a5.svg";